/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-30 11:26:29
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2021-02-06 15:00:23
 */

import Vue from 'vue'

// 获取sessionStorage
export const getSessionStorage = (name) => {
  if (!name) return
  const sessionStorage = window.sessionStorage.getItem(name)
  return sessionStorage
}
export const setSessionStorage = (name, value) => {
  if (!name) return
  if (typeof value !== 'string') {
    value = JSON.stringify(value)
  }
  window.sessionStorage.setItem(name, value)
}
// 删除sessionStorage存储数据
export const removeSessionStorage = (name) => {
  if (!name) return
  window.sessionStorage.removeItem(name)
}
// 清空sessionStorage存储数据
export const clearSessionStorage = () => {
  window.sessionStorage.clear()
}

// 获取sessionStorage方法挂载于Vue
Vue.prototype.$getSessionStorage = getSessionStorage
Vue.prototype.$setSessionStorage = setSessionStorage
Vue.prototype.$removeSessionStorage = removeSessionStorage
Vue.prototype.$clearSessionStorage = clearSessionStorage
